export enum PartnerColumn {
  Logo = 'logo',
  Name = 'name',
  Email = 'email',
  Actions = 'actions',
}

export namespace PartnerColumn {
  export const allColumns: string[] = [
    PartnerColumn.Logo,
    PartnerColumn.Name,
    PartnerColumn.Email,
    PartnerColumn.Actions,
  ];

  export const displayedColumns: string[] = [
    PartnerColumn.Logo,
    PartnerColumn.Name,
    PartnerColumn.Email,
    PartnerColumn.Actions,
  ];

  export const translateKey = (column: string): string => {
    switch (column) {
      case PartnerColumn.Logo:
        return 'partners.list.columns.logo';
      case PartnerColumn.Name:
        return 'partners.list.columns.name';
      case PartnerColumn.Email:
        return 'partners.list.columns.email';
      case PartnerColumn.Actions:
        return 'partners.list.columns.actions';
      default:
        return '';
    }
  };

  export const sortField = (column: string): string => {
    switch (column) {
      case PartnerColumn.Name:
        return 'name';
      case PartnerColumn.Email:
        return 'email';
      default:
        return '';
    }
  };

  export const filter = (columns: string[]): string[] => {
    return columns.filter((column) => allColumns.includes(column));
  };
}
